"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledDilogTitle = exports.StyledDialogContentText = exports.StyledDialogActions = void 0;

var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@mui/material/DialogContentText"));

var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));

var _Divider = _interopRequireDefault(require("@mui/material/Divider"));

var _styles = require("@mui/material/styles");

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton"));

var _jsxRuntime = require("react/jsx-runtime");

var StyledDilogTitle = (0, _styles.styled)(_DialogTitle.default)(function () {
  return "\n  font-size: 1.125rem;\n  font-weight: bold;\n";
});
exports.StyledDilogTitle = StyledDilogTitle;
var StyledDialogContentText = (0, _styles.styled)(_DialogContentText.default)(function () {
  return "\n  font-size: 0.75rem;\n";
});
exports.StyledDialogContentText = StyledDialogContentText;
var StyledDialogActions = (0, _styles.styled)(_DialogActions.default)(function () {
  return "\n  padding: 1rem 1rem 1rem 0;\n";
});
exports.StyledDialogActions = StyledDialogActions;

var DeleteDialog = function DeleteDialog(_ref) {
  var open = _ref.open,
      toggle = _ref.toggle,
      labels = _ref.labels,
      onAccept = _ref.onAccept,
      onCancel = _ref.onCancel,
      canManageOptions = _ref.canManageOptions;

  var onClose = function onClose(_event, reason) {
    // Only close when close icon is pressed or escape
    if (reason === "backdropClick") {
      return;
    }

    toggle();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog.default, {
    open: open,
    onClose: onClose,
    maxWidth: "md",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledDilogTitle, {
      children: [labels.deleteTitle, /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        iconName: "times",
        iconStyle: "fas",
        size: "large",
        "aria-label": labels.iconClose,
        borderless: true,
        onClick: toggle,
        sx: {
          position: "absolute",
          right: 8,
          top: 8,
          color: function color(theme) {
            return theme.palette.grey[600];
          }
        }
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDialogContentText, {
        children: labels.deleteConfirmation
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledDialogActions, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.default, {
        onClick: onCancel,
        variant: "outlined",
        label: labels.buttonCancel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.default, {
        variant: "contained",
        label: labels.buttonDelete,
        disabled: !canManageOptions,
        onClick: onAccept
      })]
    })]
  });
};

var _default = DeleteDialog;
exports.default = _default;